import { lazy, Suspense } from 'react'
import styled from 'styled-components'
import { LoadingDots } from '@navinc/base-react-components'

const GoldenCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh * 1 / ${({ theme = {} }) => theme.goldenRatio});

  & > * {
    color: ${({ theme = {} }) => theme.navBlue};
  }
`

export const CenteredLoadingComponent = () => (
  <GoldenCenter data-testid="centered-loading">
    <LoadingDots />
  </GoldenCenter>
)

/** @typedef {<T extends React.ComponentType<any>, I extends { [K2 in K]: T }, K extends keyof I>(factory: () => Promise<I>, name: K) => import('react').ComponentType} AsyncNamedComponent */

/** @type {AsyncNamedComponent} */
export const asyncComponent = (getComponent, name) => {
  const LazyComponent = lazy(() => getComponent().then((module) => ({ default: module[name] })))

  return (props) => (
    <Suspense fallback={<CenteredLoadingComponent />}>
      <LazyComponent {...props} />
    </Suspense>
  )
}
